// extracted by mini-css-extract-plugin
module.exports = {"close":"preferred_language_proficiency_input-module_close_6c866"};